<div
  class="origin"
  cdkOverlayOrigin
  #pickerOrigin="cdkOverlayOrigin"
></div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="pickerOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayLockPosition]="true"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositions"
  cdkConnectedOverlayPanelClass="custom-step-picker-overlay"
>
  <div class="custom-step-form" (motnClickOutsideService)="closed$.emit()">
    <input
      type="number"
      min="1"
      step="1"
      [value]="value"
      (input)="onInputChange($event)"
      (blur)="onInputBlur()"
      class="step-value-input"
    />
    <div class="unit-selector">
      <div
        class="fake-select unit-button"
        [class.open]="unitSelectorOpen"
        (click)="unitSelectorOpen = !unitSelectorOpen; $event.stopPropagation()"
      >
        {{ unit | titlecase }}
        <i class="fa-regular fa-chevron-down"></i>
      </div>
      @if (unitSelectorOpen) {
        <motn-popover-menu
          [optionGroup]="unitOptions"
          [overlayPositions]="unitDropdownPositions"
          (clickedOption$)="onUnitChange($event)"
          (clickedOutsideMenu$)="unitSelectorOpen = false"
        ></motn-popover-menu>
      }
    </div>
  </div>
</ng-template>
